export enum ButtonVariants {
  primary = 'primary',
  primaryLight = 'primaryLight',
  secondary = 'secondary',
  secondaryLight = 'secondaryLight',
  textLink = 'textLink',
}
